import { ExternalEntityType } from 'lane-shared/domains/billingPayments/types';

export const isWorkOrderPaymentsManagedExternally = (
  externallyManagedInvoiceEntityTypes?: ExternalEntityType[]
) =>
  externallyManagedInvoiceEntityTypes?.includes(
    ExternalEntityType.EXTERNAL_ENTITY_TYPE_WORKORDER
  ) ?? false;

export const getUpdatedExternallyManagedInvoiceEntityTypesForWorkOrders = (
  externallyManagedInvoiceEntityTypes: ExternalEntityType[] | undefined,
  shouldManageExternally: boolean
): ExternalEntityType[] => {
  const entityTypesWithoutWorkOrder = (
    externallyManagedInvoiceEntityTypes ?? []
  ).filter(
    entityType =>
      entityType !== ExternalEntityType.EXTERNAL_ENTITY_TYPE_WORKORDER
  );

  if (!shouldManageExternally) {
    return entityTypesWithoutWorkOrder;
  }

  return [
    ...entityTypesWithoutWorkOrder,
    ExternalEntityType.EXTERNAL_ENTITY_TYPE_WORKORDER,
  ];
};
